var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletedeactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.935,
    height: 17,
    viewBox: "0 0 14.935 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8327",
    "data-name": "Group 8327",
    transform: "translate(-457.5 -563.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M44.607,77.681H37.875a1.222,1.222,0,0,1-1.223-1.117l-1.06-11.7a.258.258,0,0,1,.257-.282H46.632a.258.258,0,0,1,.257.282l-1.06,11.7A1.222,1.222,0,0,1,44.607,77.681Z",
    transform: "translate(423.717 502.318)",
    fill: "none",
    stroke: "#d3d3d3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M116.4,3.481h-5.225a.258.258,0,0,1-.258-.258V1.618A1.043,1.043,0,0,1,111.959.576h3.657a1.043,1.043,0,0,1,1.042,1.042V3.223A.258.258,0,0,1,116.4,3.481Z",
    transform: "translate(351.195 563.424)",
    fill: "none",
    stroke: "#d3d3d3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M736,313.959h13.934",
    transform: "translate(-278.004 252.944)",
    fill: "none",
    stroke: "#d3d3d3",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M-4821.268-21686.6l-.423,6.547",
    transform: "translate(5288.871 22256.789)",
    fill: "none",
    stroke: "#d3d3d3",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M-4823.515-21686.6v6.551",
    transform: "translate(5288.473 22256.789)",
    fill: "none",
    stroke: "#d3d3d3",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M-4825.691-21686.6l.413,6.559",
    transform: "translate(5287.999 22256.789)",
    fill: "none",
    stroke: "#d3d3d3",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletedeactive);
export default __webpack_public_path__ + "static/media/deletedeactive.e505eb747d33d204317505e1dd9069aa.svg";
export { ForwardRef as ReactComponent };